module.exports = __webpack_public_path__ + "img/logo_home.6aa7f545.png";